import { navChips, siteStats } from '@/mocks/gossip';

export default function SiteFooter() {
  return (
    <footer className="border-t-4 border-accent-500 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <p className="font-heading text-3xl font-black tracking-tight text-background-50">
              91<span className="text-accent-400">吃瓜</span>
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-background-100/75">
              每日更新今日吃瓜与热门事件，聚合网红黑料、明星八卦及大瓜汇总。想知道最近谁塌房、谁翻车、谁又被锤，来这就对了。
            </p>
            <p className="mt-5 font-label text-[11px] uppercase tracking-[0.35em] text-background-100/50">
              Daily Melon Report · Vol.{siteStats.issue}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navChips.map((chip) => (
                <li key={chip.id}>
                  <a
                    href={`#${chip.id}`}
                    className="cursor-pointer text-sm text-background-100/75 transition-colors hover:text-accent-300"
                  >
                    {chip.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">关于本站</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/75">
              <li>更新时间：每日 09:00 - 24:00</li>
              <li>内容定位：公开信息聚合与整理</li>
              <li>线索投递：随时欢迎</li>
            </ul>
            <p className="mt-4 text-xs leading-relaxed text-background-100/50">
              本站人物与事件均为内容展示示例，如有雷同纯属巧合。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-100/60">
            © 2026 91吃瓜 · 理性吃瓜，开心围观
          </p>
          <p className="text-xs text-background-100/60">内容仅供信息聚合参考，请以当事人正式回应为准</p>
        </div>
      </div>
    </footer>
  );
}